export enum SilentErrorCode {
	offerAlreadyUsed = 40030,
	timeSlotsError = 40031,
	offerInactiveError = 40033,
	codeNotFoundOrInactiveError = 40034,
	refreshTokenNotPresent = 40042,
}
